import i18n from '@/plugins/i18n';
import { UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';

export class Project {
    public static Default(selected: boolean = false): Project {
        return new Project({ id: 0, name: i18n.t('common.ellipsis'), selected });
    }

    public id: number = 0;
    public name?: string;
    public zoneId: number | null = null;
    public zoneLocalizedName: any | null = null;
    public selected: boolean = false;
    public disabled: boolean = false;

    public get permissionsGroupType(): UserEntityPermissionsType {
        return UserEntityPermissionsType.Projects;
    }

    public get permissionsIdToCheck(): number {
        return this.id;
    }

    get zoneName(): string | undefined {
        let text = '';

        if (this.zoneId && this.zoneLocalizedName) {
            const resource = this.zoneLocalizedName.find((l: any) => l.culture === i18n.locale)!.resource;
            text = resource[Object.keys(resource)[0]];
        }

        return text ? i18n.t(text).toString() : undefined;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, { zoneLocalizedName: json.zoneLocalizedName ? JSON.parse(json.zoneLocalizedName) : null });

        if (this.zoneLocalizedName) {
            this.zoneLocalizedName.forEach((name: any) => {
                i18n.mergeLocaleMessage(name.culture, name.resource);
            });
        }
    }

    get value(): number {
        return this.id;
    }

    get text(): string | undefined {
        return this.name;
    }

    public clone(): Project {
        const project: Project = new Project();

        project.id = this.id;
        project.name = this.name;
        project.zoneId = this.zoneId;
        project.zoneLocalizedName = this.zoneLocalizedName ? JSON.parse(JSON.stringify(this.zoneLocalizedName)) : null;
        project.selected = this.selected;
        project.disabled = this.disabled;

        return project;
    }
}
